<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button :disabled="!order.isNew()" content="button.reset" icon="vxe-icon-undo" mode="text" status="danger" @click="clear"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.addDetail" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.submit" icon="vxe-icon-signature" mode="text" status="primary" @click="submit"/>
        <!--          <a-upload :multiple="true" name="file">-->
        <!--            <a-button type="primary" @click="importExcel">-->
        <!--              <a-icon type="upload" />-->
        <!--              {{ $t('button.impConfirm') }}-->
        <!--            </a-button>-->
        <!--          </a-upload>-->
      </template>
      <a-form-model :colon="false" :label-col="labelCol" :model="order" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderNo')" prop="no">
              <vxe-input v-model="order.no" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderType')" prop="orderType">
              <vxe-input v-model="order.orderType.name" :disabled="order.orderStatus>0" :editable="false" style="width: 100%" @click="onOrderTypeSelect"/>
              <order-type-modal ref="orderTypeModal" @change="onOrderTypeChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.owner')" prop="owner">
              <vxe-select v-model="order.owner.id" :disabled="order.orderStatus>0" :options="owners" style="width: 100%" @change="onOwnerChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.customer')" prop="customer">
              <vxe-input v-model="order.customer.name" :disabled="order.orderStatus>0" :editable="false" style="width: 100%" @click="onCustomerSelect"/>
              <customer-modal ref="customerModal" title="business.label.customer" @change="onCustomerChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.detailAddress')" prop="address">
              <vxe-input v-model="order.address.addressInfo.detailAddress" :disabled="order.orderStatus>0" :editable="false" style="width: 100%" @click="onAddressSelect"/>
              <address-modal ref="addressModal" @change="onAddressChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.pickupMode')" prop="pickupMode">
              <vxe-select v-model="order.pickupMode.id" :disabled="order.orderStatus>0" :options="pickupModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.logicalStore')" prop="logicalStore">
              <vxe-select v-model="order.logicalStore.id" :disabled="order.orderStatus>0" :options="logicalStores" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.maker')" prop="operator">
              <vxe-input v-model="order.operator" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.businessman')" prop="businessman">
              <vxe-input v-model="order.businessman" :disabled="order.orderStatus>0" :editable="false" style="width: 100%" @click="onBusinessmanSelect"/>
              <user-modal ref="userModal" @change="onBusinessmanChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-row>
              <a-col :span="12">
                <a-form-model-item :label="$t('business.label.appointed')" prop="appointed">
                  <vxe-switch v-model="order.appointed" :disabled="order.orderStatus>0"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('business.label.oneStep')" prop="oneStep">
                  <vxe-switch v-model="order.oneStep" :disabled="order.orderStatus>0"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <vxe-table ref="table" :data="order.details" :edit-config="{trigger:this.order.orderStatus>0?'manual':'click'}" :edit-rules="editRules" :loading="loading" :min-height="720" keep-source>
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="itemRender" field="item.no" title="business.label.itemNo" width="100"/>
      <vxe-column field="item.name" title="business.label.itemName" width="200"/>
      <vxe-column :edit-render="packRender" field="pack.specification" title="business.label.specification" width="200"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column :edit-render="lotRender" field="lot.no" title="business.label.lot" width="120"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column :visible="!visible" field="lot.manufacturer" title="business.label.manufacturer" width="200"/>
      <vxe-column :visible="!visible" field="lot.producingArea" title="business.label.producingArea" width="120"/>
      <vxe-column :edit-render="locationRender" :visible="visible" field="location.no" title="business.label.locationNo" width="150"/>
      <vxe-column :visible="visible" field="container.no" title="business.label.containerNo" width="150"/>
      <vxe-column :edit-render="numberRender" field="plannedQuantity" title="business.label.plannedQuantity" width="150"/>
      <vxe-column fixed="right" title="business.label.operate" width="auto">
        <vxe-button-group slot-scope="{row}" mode="text">
          <vxe-button :disabled="order.orderStatus>0" content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
        </vxe-button-group>
      </vxe-column>
    </vxe-table>
    <item-modal ref="itemModal" @change="onItemChange"/>
    <pack-modal ref="packModal" @change="onPackChange"/>
    <lot-modal ref="lotModal" @change="onLotChange"/>
    <inventory-modal ref="inventoryModal" selectType="radio" @change="onLocationChange"/>
  </div>
</template>

<script>
import Vue from 'vue'
import Api from '@/api'
import { deleteOne, findAll, post } from '@/api/Api'
import moment from 'moment'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import UserModal from '@/views/modal/UserModal.vue'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'
import CustomerModal from '@/views/modal/CustomerModal.vue'
import AddressModal from '@/views/modal/AddressModal.vue'
import ItemModal from '@/views/modal/ItemModal.vue'
import PackModal from '@/views/modal/PackModal.vue'
import LotModal from '@/views/modal/LotModal.vue'
import InventoryModal from '@/views/modal/InventoryModal.vue'
import { BaseObject } from '@/api/dto/BaseObject'
import { SaleDetail, SaleOrder } from '@/api/dto/order/SaleOrder'
import { OrderType } from '@/api/dto/common/OrderType'
import { Party } from '@/api/dto/common/Party'
import { Address } from '@/api/dto/common/Address'
import { Item } from '@/api/dto/common/Item'
import { Pack } from '@/api/dto/common/Pack'
import { Lot } from '@/api/dto/common/Lot'
import { Batch } from '@/api/dto/common/Batch'
import { Location } from '@/api/dto/common/Location'
import { Container } from '@/api/dto/common/Container'

export default {
  name: 'SaleOrderDetail',
  components: { AddressModal, CustomerModal, InventoryModal, ItemModal, LotModal, OrderTypeModal, PackModal, UserModal },
  props: {
    owners: { type: Array, default: [] },
    pickupModes: { type: Array, default: [] },
    logicalStores: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      visible: false,
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      order: new SaleOrder(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        orderType: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        owner: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        customer: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        address: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        pickupMode: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      },
      editRules: {
        'item.no': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'item.name': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'plannedQuantity': [{ required: true, min: 1, type: 'number', message: '计划数量需大于0' }]
      },
      textRender: {
        name: 'VxeInput',
        autoFocus: true,
        autoSelect: true
      },
      numberRender: {
        name: 'VxeNumberInput',
        autoFocus: true,
        autoSelect: true,
        props: {
          min: 0
        }
      },
      dateRender: {
        name: 'VxeDatePicker',
        autoFocus: true,
        autoSelect: true
      },
      itemRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.onItemSelect(row),
          clear: ({ row }) => this.onItemClear(row)
        }
      },
      packRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.onPackSelect(row),
          clear: ({ row }) => this.onPackClear(row)
        }
      },
      lotRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.onLotSelect(row),
          clear: ({ row }) => this.onLotClear(row)
        }
      },
      locationRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.onLocationSelect(row),
          clear: ({ row }) => this.onLocationClear(row)
        }
      }
    }
  },
  created() {
    this.order.operator = this.operator.name
    this.order.businessman = this.operator.name
  },
  watch: {
    'order.appointed': function(newVal, oldVal) {
      if (newVal && this.order.oneStep) {
        this.order.appointed = oldVal
        this.$warning({ content: '指定下发、一键出库只能选择一种', centered: true })
      }
      this.visible = newVal
    },
    'order.oneStep': function(newVal, oldVal) {
      if (newVal && this.order.appointed) {
        this.order.oneStep = oldVal
        this.$warning({ content: '指定下发、一键出库只能选择一种', centered: true })
      }
      this.visible = newVal
    }
  },
  methods: {
    moment,
    back() {
      this.$emit('back')
    },
    fetch(row) {
      this.order = new SaleOrder(BaseObject.merge(row, 'order'))
      this.getDetails()
    },
    getDetails() {
      if (this.order.isNew()) return
      this.loading = true
      findAll('saleDetailFactory', { 'order.id': this.order.id }).then(res => {
        if (res.success) {
          this.order.details = res.result.map(item => {
            return new SaleDetail(BaseObject.merge(item, 'saleDetail'))
          })
        }
      }).finally(() => this.loading = false)
    },
    onOrderTypeSelect() {
      this.$refs.orderTypeModal.open({ available: true, operationType: 2, refundable: false })
    },
    onOrderTypeChange(data) {
      this.order.orderType = new OrderType(data[0])
    },
    onOwnerChange() {
      this.order.customer = new Party()
      this.order.address = new Address()
      this.order.details = []
    },
    onCustomerSelect() {
      if (this.checkOwner()) {
        this.$refs.customerModal.open({ available: true, 'type.ordinal': 3, 'owner.id': this.order.owner.id })
      }
    },
    onCustomerChange(data) {
      this.order.customer = new Party(data[0])
    },
    onAddressSelect() {
      this.$refs.addressModal.open({ 'customer.id': this.order.customer.id })
    },
    onAddressChange(data) {
      this.order.address = new Address(data[0])
      this.order.direction = this.order.address.direction
    },
    onBusinessmanSelect() {
      this.$refs.userModal.open({ available: true })
    },
    onBusinessmanChange(data) {
      this.order.businessman = data.length > 0 ? data[0].name : ''
    },
    onItemSelect(row) {
      if (this.checkOwner()) {
        this.$refs.itemModal.open({ 'owner.id': this.order.owner.id }, row)
      }
    },
    onItemClear(row) {
      row.item = new Item()
      row.pack = new Pack()
      row.lot = new Lot()
      row.batch = new Batch()
    },
    onItemChange(data, row) {
      row.item = new Item(data[0])
      row.pack = new Pack()
      this.onLotChange([], row)
    },
    onPackSelect(row) {
      if (this.checkItem(row)) {
        this.$refs.packModal.open({ 'item.id': row.item.id }, row)
      }
    },
    onPackClear(row) {
      row.pack = new Pack()
    },
    onPackChange(data, row) {
      row.pack = new Pack(data[0])
    },
    onLotSelect(row) {
      if (this.checkItem(row)) {
        this.$refs.lotModal.open({ 'item.id': row.item.id }, row)
      }
    },
    onLotClear(row) {
      row.lot = new Lot()
      row.batch = new Batch()
    },
    onLotChange(data, row) {
      row.lot = new Lot(data[0])
    },
    onLocationSelect(row) {
      if (this.checkOwner() && this.checkItem(row)) {
        this.$refs.inventoryModal.open({ 'owner.id': this.order.owner.id, 'item.id': row.item.id, 'pack.id': row.pack.id, 'lot.id': row.lot.id, 'batch.id': row.batch.id }, row)
      }
    },
    onLocationClear(row) {
      row.location = new Location()
      row.container = new Container()
    },
    onLocationChange(data, row) {
      const record = data[0]
      row.item = new Item(record.item)
      row.pack = new Pack(record.pack)
      if (this.visible) {
        row.lot = new Lot(record.lot)
        row.batch = new Batch(record.batch)
        row.location = new Location(record.location)
        row.container = new Container(record.container)
      }
    },
    checkOwner() {
      if (this.order.owner.isNew()) {
        this.$warning({ title: '请先选择货主', centered: true })
        return false
      }
      return true
    },
    checkItem(row) {
      if (row.item.isNew()) {
        this.$warning({ title: '请先选择商品', centered: true })
        return false
      }
      return true
    },
    verify() {
      if (this.order.orderType.isNew()) {
        this.$warning({ title: '请选择订单类型', centered: true })
        return false
      }
      if (this.order.owner.isNew()) {
        this.$warning({ title: '请选择货主', centered: true })
        return false
      }
      if (this.order.customer.isNew()) {
        this.$warning({ title: '请选择客户', centered: true })
        return false
      }
      if (this.order.pickupMode.isNew()) {
        this.$warning({ title: '请选择提货方式', centered: true })
        return false
      }
      if (this.order.details.length === 0) {
        this.$warning({ title: '请添加明细', centered: true })
        return false
      }
      return true
    },
    reset() {
      this.order = new SaleOrder()
      this.order.orderStatus = 0
      this.order.operator = this.operator.name
      this.order.businessman = this.operator.name
    },
    clear() {
      const that = this
      that.$confirm({
        title: '将清空界面数据',
        content: '是否确定',
        onOk() {
          that.reset()
        },
        onCancel() {
        },
        centered: true
      })
    },
    add() {
      this.order.details.push(new SaleDetail())
    },
    async save() {
      const pass = this.verify()
      if (!pass) {
        return
      }
      const table = this.$refs.table
      const errMap = await table.validate(true)
      if (!errMap) {
        this.loading = true
        const order = this.order.toJSONObject()
        order.warehouse = this.warehouse
        order.address = this.order.address.isNew() ? undefined : { id: this.order.address.id }
        order.details = this.order.details.map(dtl => {
          const detail = dtl.toJSONObject()
          detail.actualQuantity = detail.plannedQuantity
          return detail
        })
        post(Api.sellingSave, { type: 'optionalSeller' }, order).then(res => {
          if (res.success) {
            this.$message.success(this.$t('message.saveSuccess'))
            this.order = new SaleOrder(res.result)
            this.getDetails()
          }
        }).finally(() => this.loading = false)
      }
    },
    async submit() {
      await this.save()
      this.loading = true
      post(Api.sellingSubmit, { type: 'optionalSeller' }, { id: this.order.id }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.order = new SaleOrder(res.result)
          this.getDetails()
        }
      }).finally(() => this.loading = false)
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('saleDetailDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.$message.success(this.$t('message.deleteSuccess'))
            this.fetch()
          }
        }).finally(() => this.loading = false)
      } else {
        this.order.details.splice(this.order.details.indexOf(row), 1)
      }
    }
  }
}
</script>